import { z } from 'zod';

export const OpenAIFunctionCallKwargsSchema = z.object({
  function_call: z.object({
    name: z.string(),
    arguments: z.string(),
  }),
});
export type OpenAIFunctionCallKwargs = z.infer<
  typeof OpenAIFunctionCallKwargsSchema
>;

export const OpenAIToolCallsKwargsSchema = z.object({
  tool_calls: z.array(
    z.object({
      id: z.string(),
      type: z.literal('function'),
      function: z.object({
        name: z.string(),
        arguments: z.string(),
      }),
    })
  ),
});
export type OpenAIToolCallsKwargs = z.infer<typeof OpenAIToolCallsKwargsSchema>;

export const ToolCallsKwargsSchema = z.object({
  tool_calls: z.array(
    z.object({
      id: z.string().optional(),
      name: z.string(),
      args: z.record(z.any()),
    })
  ),
});
export type ToolCallsKwargs = z.infer<typeof ToolCallsKwargsSchema>;

export const OpenAIToolMessageKwargsSchema = z.object({
  tool_call_id: z.string(),
  name: z.string().optional(),
});
export type OpenAIToolMessageKwargs = z.infer<
  typeof OpenAIToolMessageKwargsSchema
>;
